import { css } from 'linaria';

export const catalogList = css`
  @media (--from-tablet) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 32px;
    row-gap: 48px;
  }

  @media (--only-tablet) {
    grid-template-columns: repeat(2, 1fr);
  }
`;
